import { render, staticRenderFns } from "./appendix1.vue?vue&type=template&id=c84d541e&scoped=true&"
import script from "./appendix1.vue?vue&type=script&lang=js&"
export * from "./appendix1.vue?vue&type=script&lang=js&"
import style0 from "./appendix1.vue?vue&type=style&index=0&id=c84d541e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d541e",
  null
  
)

export default component.exports